import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OTPModel, ValidUserResponseModel } from './forgot-password.model';

@Injectable({
    providedIn: 'root'
})
export class ForgotPasswordService {
    constructor(private http: HttpClient) { }

    checkValidUser(obj) : Observable<ValidUserResponseModel> {
        const url = environment.token_url + 'user/forgot-password';
        return this.http.post(url , obj).pipe(map((response: ValidUserResponseModel) => {
            return response;
        }));
    }

    updatePassword(data): Observable<any> {
        const url = environment.token_url + 'user/reset-password';
        return this.http.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }

}
